import ModernVerification from './ModernVerification';

function VerificationDefault() {
  return <ModernVerification />;
}

export default VerificationDefault;
